/* Page guide des tailles : affordance de défilement des tableaux.
   Même logique que size-guide-html.js, mais les tableaux sont dans le flux
   de la page, donc pas d'ouverture de modale à observer. */
(function () {
  'use strict';

  function sync(scroller) {
    var wrap = scroller.querySelector('[data-sgp-scroll]');
    if (!wrap) return;
    var slack = wrap.scrollWidth - wrap.clientWidth;
    scroller.classList.toggle('is-scrollable', slack > 4);
    scroller.classList.toggle('is-end', wrap.scrollLeft >= slack - 4);
  }

  function init(scroller) {
    if (scroller.dataset.sgpInit) return;
    scroller.dataset.sgpInit = '1';
    var wrap = scroller.querySelector('[data-sgp-scroll]');
    if (!wrap) return;
    wrap.addEventListener('scroll', function () { sync(scroller); }, { passive: true });
    sync(scroller);
  }

  function boot() {
    document.querySelectorAll('[data-sgp-scroller]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-sgp-scroller]').forEach(sync);
  });

  /* l'éditeur de thème réinjecte la section à chaque modification */
  document.addEventListener('shopify:section:load', boot);
})();
